import {
  DESLogServerLoggerClientOptions,
} from '@des/services/logging';

/**
 * DEFAULT server logger client options for SSCI
 */
export const SSCI_SERVER_LOGGER_CLIENT_OPTIONS: Partial<DESLogServerLoggerClientOptions> = {
  appName: 'RefX-Ssci'
};
